import { init } from "./sdk/init";
init();
